export default __webpack_public_path__ + "static/media/right_highArch.d46d6eb2.png";